import { render } from "./AIconButton.vue?vue&type=template&id=7d476792"
import script from "./AIconButton.vue?vue&type=script&lang=js"
export * from "./AIconButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__